import Vue from 'vue'
import Vuex, { StoreOptions } from 'vuex'
import { RootState } from './types'
import { content } from './content/index'
import VuexPersistence from 'vuex-persist'
import { account } from './account'
import { AccountState } from './account/types'

const vuexLocal = new VuexPersistence({
  reducer: (state: RootState) => ({
    account: {
      token: (state.account as AccountState).token,
      email: (state.account as AccountState).email,
      loggedIn: (state.account as AccountState).loggedIn,
      firstName: (state.account as AccountState).firstName
    }
  })
})

Vue.use(Vuex)

const storeOptions: StoreOptions<RootState> = {
  state: {
    version: '1.0.0',
    content: content.state,
    account: account.state
  },
  modules: {
    content,
    account
  },
  plugins: [
    vuexLocal.plugin
  ]
}

export default new Vuex.Store<RootState>(storeOptions)
